import React from 'react'
import { AppBar, Grid, Link, Toolbar } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { HeaderUserControls, MobileMenuIcon, ThemeSwitch } from '../../components'
import { Icon } from '../../components'
import { APP_ROUTES, COMPANY_PHONES, CONTENT_PADDING, CONTENT_WIDTH } from '../../constants.ts'
import { useApplicationTheme } from '../../contexts'
import { useUser } from '@/stores/slices/user-slice.ts'

export const Header = (): React.ReactElement => {
  const { theme } = useApplicationTheme()
  const user = useUser()

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          color: 'text.primary',
          py: 1.5,
        }}
      >
        <Toolbar disableGutters>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              maxWidth: CONTENT_WIDTH,
              margin: '0 auto',
              px: CONTENT_PADDING,
            }}
          >
            <Grid item xs={4}>
              <Link component={RouterLink} to={user ? APP_ROUTES.SbpPayments : APP_ROUTES.Login}>
                <Icon name={theme === 'dark' ? 'CifraBankLightIcon' : 'CifraBankIcon'} size="initial" />
              </Link>
            </Grid>
            <Grid item xs={8} container flexDirection="row" justifyContent="flex-end" alignItems="center" spacing={1.5}>
              <Grid item sx={{ display: { xs: 'none', md: 'initial' } }}>
                <Link variant="h6" href={`tel:${COMPANY_PHONES[0]}`} color="inherit">
                  {COMPANY_PHONES[0]}
                </Link>
              </Grid>
              <Grid item sx={{ display: { md: 'none' } }}>
                <MobileMenuIcon />
              </Grid>
              <HeaderUserControls />
              <Grid item>
                <ThemeSwitch />
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  )
}
